import React from 'react';
import { brand } from '../../styles/theme';

// Encabezado de grupo del editor. Los cuatro bloques (Información Básica,
// Contenido Multimedia, Vídeo y Contenido Principal) llevaban cada uno un color
// distinto (azul, verde, naranja, púrpura); ahora comparten el rojo profundo de
// marca y el mismo tratamiento tipográfico.
const SectionKicker = ({ icon: Icon, children }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      paddingBottom: 12,
      marginBottom: 18,
      borderBottom: '1px solid #f0f1f3'
    }}
  >
    <Icon style={{ color: brand.deep, fontSize: 17 }} />
    <span
      style={{
        fontSize: 13,
        fontWeight: 700,
        color: brand.deep,
        textTransform: 'uppercase',
        letterSpacing: '0.04em'
      }}
    >
      {children}
    </span>
  </div>
);

export default SectionKicker;
